import React, { Component } from 'react';
import {Link} from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from "react-router-dom";
import { getlanguagelist } from "../../../helpers/changelanguage";
import moment from 'moment';
import { CircularProgress } from '@material-ui/core';
import './AllChat.css';
import $$ from 'jquery';
import { getChatlist } from "../../../actions/chatAction";
import { loader} from '../../../actions/utils';


class AllChat extends Component {
    constructor(props) {
        super(props);
        this.state = {
            current_user    : '',
            chat_list_display : false,
            chat_list : [],
            loader : 'none',
            pagination : 0,
            serchchatfield : '',
            serchchat : ''
            
        };
        
        this.openChatList           = this.openChatList.bind(this);
        this.closeChatList          = this.closeChatList.bind(this);
        this.chk_scroll_chatList    = this.chk_scroll_chatList.bind(this);
        this.getChatlist            = this.getChatlist.bind(this);
        this.serchChat              = this.serchChat.bind(this);
        this.doSearch               = this.doSearch.bind(this);
        
    };

    serchChat(e){
        this.setState({
            [e.target.name]: e.target.value,
        });
    }

    doSearch(){
        const wordCount = this.state.serchchatfield === "" ? 0 : this.state.serchchatfield.split("").length;
        if(wordCount >= 3 || this.state.serchchatfield==='') 
        {
            this.setState({
                loader         : 'block',
                serchchat      : this.state.serchchatfield,
                pagination     : 0,
                chat_list      : []
            },function(){            
                if(wordCount >= 3) 
                {
                    this.getChatlist();
                }
                if(this.state.serchchat == '') 
                {
                    this.getChatlist();
                }
            }); 
        }       
    }

    

    componentDidMount(){
        
        //this.getChatlist();
        
        //$$('.chat-wrapper').bind('scroll',this.chk_scroll_chatList);
    }

    chk_scroll_chatList(e){
       
        var elem = $(e.currentTarget);
        
        if (elem[0].scrollHeight - elem.scrollTop() >= elem.outerHeight())
        {  
            
            if((this.state.last_res_counter >= 24) && (localStorage.getItem('apicall') == '0')){
                this.setState({
                    loader     : 'block',
                    pagination : this.state.pagination + 1
                },function(){
                    this.getChatlist();
                });
            }
        }
       
    }

    getChatlist(){
        localStorage.setItem('apicall','1');
        
        //search     : this.state.serchchat,
        let param = {
          pagination : this.state.pagination,
          search     : this.state.serchchat
        }
        console.log('param :: ',param);
        let chatlist = this.props.getChatlist(param);
    }


    openNewChatBox(list){
        let add         = [];
        add.user_id     = list.chat_id;
        add.name        = list.chat_name;
        add.image       = list.image_name;
        add.status      = '0';
        this.setState({ chat_list_display: false});
        this.props.openChatBox(add);
    }

    UNSAFE_componentWillReceiveProps(nextProps,prevProps){
        
        if(this.props.chatlist != nextProps.chatlist){
            
            let chats = this.state.chat_list;

            if (this.state.pagination == 0) {
                chats =  [...nextProps.chatlist];
            }else{
                let nextchats = nextProps.chatlist;
                
                if(nextchats !== this.props.chatlist){
                  Object.keys(nextchats).map((key) => {
                    chats.push(nextchats[key]);
                  });
                }
            }
            
            localStorage.setItem('apicall','0');            
            this.setState({
                chat_list   : chats,
                last_res_counter  : nextProps.chatlist.length,
                loader : 'none'
            });

        }

        if(this.props.all_chatList_display != nextProps.all_chatList_display){
            if(nextProps.all_chatList_display === false){
                this.closeChatList();
            }
        }
    }
    

    openChatList(){
        this.setState({
            chat_list : [],
            loader    : 'block'
        });
        this.getChatlist();
        $$('.chat-wrapper').bind('scroll',this.chk_scroll_chatList);

        if(this.state.chat_list_display === false){
            this.setState({ chat_list_display: true});
            this.props.openChatList(true);
        }
        else{
            this.setState({ chat_list_display: false});
            this.props.openChatList(false);
        }
        
    }

    closeChatList(){
        this.setState({ chat_list_display: false});
    }
    
    render() {
        let  languagelist = getlanguagelist();
        const chatlistStyle = {
            display :  this.state.chat_list_display === true ? 'block' : 'none'
        };
        //console.log('all chat state ::',this.state.chat_list);
        return (
            <div>
                                
                <div className="fixed-action-btn"> 
                    <a href="#" onClick={this.openChatList} className="btn-floating btn-lg"> 
                        <img src="/assets/images/chat-ico.png" width="40" /> 
                    </a> 
                </div>
                <div className="chat-box" style={chatlistStyle}>
                    <div className="chat-header">
                        <h4>Message</h4>
                        <a href="#" onClick={this.closeChatList} className="chat-close">X</a>
                    </div>
                    <div className="chat-wrapper">

                        <ul>
                            <li>
                                <input type="text"
                                    className="search_chat"  
                                    name="serchchatfield" 
                                    value={this.state.serchchatfield} 
                                    placeholder={languagelist.search_1} 
                                    onChange={this.serchChat}
                                    onKeyUp={this.doSearch}/>
                            </li>
                            {
                                (this.state.chat_list).map((list,index) => {
                                    return (
                                        <li className="" key={index}>
                                            <a href="#" onClick={this.openNewChatBox.bind(this, list)} className="chat-list_details msg-active">
                                                <div className="chat-part-left">
                                                    <h4>{list.chat_name}</h4>
                                                    <p>{list.mutual_friend} mutual friend</p>
                                                </div>
                                                <div className="chat-part-right">
                                                    {
                                                        (list.created_at != '') ?
                                                        <span>{(moment(list.created_at).format('MMM Do YYYY'))}</span>
                                                        : null
                                                    }
                                                    {/* <p className="msg-numbers">2</p> */}
                                                </div>
                                                <div className="clear"></div>
                                            </a>
                                        </li>
                                    )
                                })
                            }
                            <li className="" style={{display : `${this.state.loader}`}}>
                                <CircularProgress />
                            </li>
                            <div className="clear"></div>
                        </ul>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
      me         : state.login.user,
      chatlist   : state.chatuserlist.chatList.list,
    }
}

const mapDispatchToProps = dispatch => {
    return {
      getChatlist      : bindActionCreators(getChatlist, dispatch),
    }
}

export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(AllChat));
//export default AllChat;